"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var LoupeIcon_1 = __importDefault(require("../../Icon/LoupeIcon"));
var Input_1 = __importDefault(require("../inputs/Input"));
var FrmCompCSS = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px 30px;\n  background-color: #e5ebf0;\n  border-bottom: 1px solid #d5e1eb;\n  font-size: 15px;\n  color: #000000;\n  width: 100%;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.01);\n"], ["\n  padding: 20px 30px;\n  background-color: #e5ebf0;\n  border-bottom: 1px solid #d5e1eb;\n  font-size: 15px;\n  color: #000000;\n  width: 100%;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.01);\n"])));
var FullTextField = function (_a) {
    var name = _a.name, placeholder = _a.placeholder, toolTip = _a.toolTip, defaultValue = _a.defaultValue;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    react_1.useEffect(function () {
        if (defaultValue)
            helpers.setValue(defaultValue.value);
    }, [defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value]);
    return (react_1.default.createElement(FrmCompCSS, null,
        react_1.default.createElement(Input_1.default, __assign({}, field, { value: field.value || '', placeholder: placeholder, name: name, hasError: !!meta.error, toolTip: toolTip })),
        react_1.default.createElement(LoupeIcon_1.default, { isWithPosition: true })));
};
FullTextField.defaultProps = {
    toolTip: undefined,
    defaultValue: undefined,
};
exports.default = FullTextField;
var templateObject_1;
